import { useAppSelector } from '../../../../store/hooks';
import { getAreCampaignsFiltersVisible } from '../../selectors/get-are-campaigns-filters-visible/get-are-campaigns-filters-visible.selector';

export const useAreCampaignsFiltersVisible = (): boolean => {
  return useAppSelector(getAreCampaignsFiltersVisible);
};
